const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null
};

const reducer = (state = INIT_STATE, action) => {
	switch (action.type) {
		case 'GET_VIEWS':
			return { ...state, loading: true, error: false, errorMessage: null, action: null, list: [] };

		case 'GET_VIEWS_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_VIEWS_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_VIEW':
			return { ...state, loading: true, error: false, action: null };

		case 'GET_VIEW_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_VIEW_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_VIEW':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_VIEW_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED' }

		case 'CREATE_VIEW_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_VIEW':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_VIEW_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED' }

		case 'UPDATE_VIEW_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_VIEW':
			return { ...state, loading: true, action: null }

		case 'DELETE_VIEW_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_VIEW_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;
	}
};

export default reducer;